import { render, staticRenderFns } from "./PointStatusBadge.vue?vue&type=template&id=612d5977&"
import script from "./PointStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PointStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports